import { clone } from "chart.js/helpers";
export function getStartOfToday() {
    let now = new Date(Date.now());
    now.setHours(0, 0, 0, 0);
    return now;
}
export function getStartOfTomorrow() {
    let now = new Date(Date.now());
    now.setHours(0, 0, 0, 0);
    now.setDate(now.getDate() + 1);
    return now;
}
export function getOneWeekAgo() {
    let now = new Date(Date.now());
    now.setHours(0, 0, 0, 0);
    now.setDate(now.getDate() - 7);
    return now;
}
export function secondsToShortForm(inputSeconds) {
    let names = [
        "", "k", "m", "b"
    ];
    let index = 0;
    for (let id of names) {
        if (inputSeconds / 1000 > 1) {
            index++;
            inputSeconds = inputSeconds / 1000;
            continue;
        }
        else {
            break;
        }
    }
    inputSeconds = Math.round(inputSeconds * 100) / 100;
    return inputSeconds.toString() + " " + names[index];
}
/**
 * Converts seconds into a duration format
 * @param inputSeconds
 * @returns
 */
export function secondsToDurationString(inputSeconds) {
    let factors = [
        60, 60, 24
    ];
    let result = "";
    for (let factor of factors) {
        let remainder = inputSeconds % factor;
        if (result != "") {
            result = remainder.toString() + ":" + result;
        }
        else {
            result = remainder.toString();
        }
        inputSeconds -= remainder;
        let totals = inputSeconds / factor;
        inputSeconds = totals;
        if (inputSeconds == 0) {
            break;
        }
    }
    if (inputSeconds > 0) {
        if (result != "") {
            result = inputSeconds.toString() + ":" + result;
        }
        else {
            result = inputSeconds.toString();
        }
    }
    return result;
}
/**
 * Turns an aggregation string into the corresponding seconds
 * @param str an aggregration string containings a number and an identifier d|min|h
 * @returns
 */
export function parseIntervalStringToSeconds(str) {
    var seconds = 0;
    var weeks = str.match(/(\d+)\s*w/);
    var days = str.match(/(\d+)\s*d/);
    var hours = str.match(/(\d+)\s*h/);
    var minutes = str.match(/(\d+)\s*min/);
    if (weeks) {
        seconds += parseInt(weeks[1]) * 86400 * 7;
    }
    if (days) {
        seconds += parseInt(days[1]) * 86400;
    }
    if (hours) {
        seconds += parseInt(hours[1]) * 3600;
    }
    if (minutes) {
        seconds += parseInt(minutes[1]) * 60;
    }
    return seconds;
}
/**
 * Creates an array from from to to increasing by groupingInterval
 * @param from
 * @param to
 * @param groupingInterval
 * @returns
 */
export function buildContinuesTimeFrameLabels(from, to, groupingInterval) {
    let incrementSeconds = parseIntervalStringToSeconds(groupingInterval);
    let result = [];
    let current = from;
    while (current.getTime() < to.getTime()) {
        result.push(current);
        let prev = current;
        current = new Date(prev.getTime() + (incrementSeconds * 1000));
    }
    return result;
}
export function extendTimedKeys(from, to, groupingInterval, map) {
    let keys = buildContinuesTimeFrameLabels(from, to, groupingInterval);
    let result = new Map();
    keys.forEach((key) => {
        if (map.has(key)) {
            result.set(key, map.get(key));
        }
        else {
            result.set(key, 0);
        }
    });
    return result;
}
